import { EMPTY, fromEvent, map, Observable, of } from "rxjs";

interface Umami {
    track: () => Promise<string>
}

declare global {
    interface Window { umami?: Umami; }
}

export function getUmami(): Observable<Umami> {
    if("umami" in window)
        return of(window.umami);
    else if(document.getElementById("umami-script"))
        return fromEvent(document.getElementById("umami-script"), "load").pipe(map(() => window.umami));
    else
        return EMPTY;
}